import styled from "styled-components";

export const RoutesWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  width: 100%;
`;
